import { createBrowserHistory } from 'history'
import React from 'react'

import init from '../init'
import render from '../render'

export default (exposedComponents, preloadedComponents) => {
  const history = createBrowserHistory()
  const { store } = init({
    history,
    preparedState: {
      page: global.PAGE,
      ...global.STATE
    }
  })
  const renderedComponents = render({
    history,
    store,
    components: exposedComponents
  })

  if (process.env.NODE_ENV !== 'production') {
    global.app = {
      exposedComponents,
      preloadedComponents,
      renderedComponents,
      history,
      store
    }
    global.React = React
  }
}
